import {Component, effect, forwardRef, input, output, signal} from '@angular/core';
import {SelectModule} from 'primeng/select';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {SelectTranslationOption} from './select.types';

@Component({
  selector: 'app-select',
  imports: [SelectModule, TranslateDirectusPipe, FormsModule, TranslocoPipe],
  templateUrl: './select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements ControlValueAccessor {
  relationshipId = input<string | null>(null);
  options = input<SelectTranslationOption[]>([]);
  disabled = input(false);
  placeholder = input.required<string>();

  relationshipIdChange = output<any | null>();

  selectedItem = signal<any | null>(null);

  appendTo = signal('body');
  styleClass = signal('w-full');

  private onChange: (value: any) => void = (value) => {
    this.selectedItem.set(value);
    this.relationshipIdChange.emit(value);
  };
  private onTouched: () => void = () => {
    // not implemented
  };

  writeValue(obj: any): void {
    const item = this.options().find((option) => option.id === obj || option === obj) || null;
    this.selectedItem.set(item);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // not implemented
  }

  constructor() {
    effect(() => {
      const id = this.relationshipId();
      const obj = this.options().find((option) => option.id === id) || null;
      this.selectedItem.set(obj);
    });
  }

  onSelect(obj: any) {
    this.onChange(obj);
    this.onTouched();
  }
}
